module.exports = __webpack_public_path__ + "static/media/SOMEIP-Protocol-Analyzer_S.4b3d90fd.jpg";